import { render } from "./ProfileIcon.vue?vue&type=template&id=0551b0c0&ts=true"
import script from "./ProfileIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/ProfileIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0551b0c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0551b0c0', __exports__)) {
    api.reload('0551b0c0', __exports__)
  }
  
  module.hot.accept("./ProfileIcon.vue?vue&type=template&id=0551b0c0&ts=true", () => {
    api.rerender('0551b0c0', render)
  })

}


export default __exports__